import { ReactElement } from 'react';

import { FormHandles } from '@unform/core';

import { DatePicker, InputSearch, InputSearchForm, Select } from '~/components';
import { IUserListFilters } from '~/models/UserListFilters';

import * as S from './styles';

interface IFilterFormProps {
  formName: string;
  formRef: React.RefObject<FormHandles>;
  handleSubmit: (data: IUserListFilters) => void;
}

function FilterForm({
  formName,
  formRef,
  handleSubmit,
}: IFilterFormProps): ReactElement {
  const registerStatusOptions = [
    { label: 'Ativos', value: 'true' },
    { label: 'Inativos', value: 'false' },
  ];

  const paymentStatusOptions = [
    { label: 'Pago', value: 'paid' },
    { label: 'Pedente', value: 'pending' },
    { label: 'Expirado', value: 'expired' },
    { label: 'Cancelado', value: 'canceled' },
  ];

  return (
    <S.FilterForm id={formName} ref={formRef} onSubmit={handleSubmit}>
      <S.SearchWrapper>
        <S.Label htmlFor="search">Buscar por nome, email ou cpf</S.Label>
        <InputSearchForm
          hideBtn
          placeholder="Digite..."
          name="search"
          onSearch={(value) => console.log(value)}
        />
      </S.SearchWrapper>
      <DatePicker
        fieldLabel="Filtrar por data de cadastro"
        name="start_register_at"
      />
      <Select
        name="register_status"
        fieldLabel="Filtrar por status de cadastro"
        initialValue={{ label: 'Todos', value: '' }}
        options={registerStatusOptions}
      />
      <Select
        name="payment_status"
        fieldLabel="Filtrar por status de pagamento"
        initialValue={{ label: 'Todos', value: '' }}
        options={paymentStatusOptions}
      />
    </S.FilterForm>
  );
}

FilterForm.defaultProps = {};

export default FilterForm;
